import { useState } from "react";
import api from "../../api";
import Div from "../../Components/Div";
import Li from "../../Components/Li";
import MyButton from "../../Components/MyButton";
import Container from "../../Components/Container";
import useFetchUserData from "../../customHooks/useFetchUserData";
import MySnackBar from "../../Components/MySnackBar";
import MyInput from "../../Components/MyInput";

export default function SuperAdminNotifications() {
    const userData = useFetchUserData();
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [notificationTitle, setNotificationTitle] = useState("");
    const [notificationText, setNotificationText] = useState("");
    const [notificationTokens, setNotificationTokens] = useState([]);
    const [search, setSearch] = useState("");
    const [clients, setClients] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);

    const closeSnack = () => {
        setOpen(false);
    };

    const searchClient = () => {
        api.post("/searchClient", {search}, {
            headers: { "Content-Type": "application/json" },
        }).then(({data}) => {
            setClients(data)
        })
    }

    const selectAllWithToken = () => {
        api.post("/getClientsWithPushToken", {}, {
            headers: { "Content-Type": "application/json" },
        }).then(({data}) => {
            setSelectedClients(data.clients || [])
            setOpen(true)
            setStatus("success")
            setMessage(`Выбрано клиентов: ${data.clients?.length || 0}`)
        }).catch((e) => {
            console.log(e)
            setOpen(true)
            setStatus("error")
            setMessage("Ошибка при получении клиентов")
        })
    }

    const sendNotification = () => {
        if (notificationTitle === "" || notificationText === "") {
            setOpen(true)
            setStatus("error")
            setMessage("Введите заголовок и текст уведомления")
            return
        }
        if (selectedClients?.length === 0) {
            setOpen(true)
            setStatus("error")
            setMessage("Выберите клиентов")
            return
        }
        const notificationTokens = selectedClients.map(client => client.notificationPushToken);
        console.log(notificationTokens)
        api.post("/sendNotification", {title: notificationTitle, text: notificationText, tokens: notificationTokens}, {
            headers: { "Content-Type": "application/json" },
        }).then(({data}) => {
            console.log(data)
        })
    }

    return (
        <div className="relative">
            <Container role={userData?.role}>
                
                <Div>Отправка уведомлений</Div>
                <Div />
                <Div>
                    Поиск клиента:
                    <MyInput
                        value={search}
                        change={(e) => {setSearch(e.target.value)}}
                        color="white"
                    />
                    <MyButton click={searchClient}>Найти</MyButton>
                </Div>
                <Div>Найденные клиенты:</Div>
                {clients && clients?.length > 0 && clients?.map((client) => {
                    return <div key={client?._id}>
                        <Li>
                            <div>{client?.fullName} {client?.userName} {client?.phone}</div>
                            <MyButton click={() => {setSelectedClients(prev => [...prev, client])}}>Выбрать</MyButton>
                        </Li>
                    </div>
                })}
                <Div />
                <Div>
                    <MyButton click={selectAllWithToken}>Выбрать всех с push-токеном</MyButton>
                </Div>
                <Div />
                <Div>Выбранные клиенты: {selectedClients?.length > 0 && <span className="text-red">{selectedClients.length}</span>}</Div>
                {selectedClients && selectedClients?.length > 0 && selectedClients?.map((client) => {
                    return <div key={client?._id}>
                        <Li>
                            <div>{client?.fullName} {client?.userName} {client?.phone}</div>
                            <MyButton click={() => {setSelectedClients(prev => prev.filter(c => c?._id !== client?._id))}}>Убрать</MyButton>
                        </Li>
                    </div>
                })}
                <Div />
                <Div>
                    Заголовок уведомления:
                </Div>
                <Li>
                    <MyInput
                        value={notificationTitle}
                        change={(e) => {setNotificationTitle(e.target.value)}}
                        color="white"
                    />
                </Li>
                <Div />
                <Div>Текст уведомления:</Div>
                <Li>
                    <textarea size={13} style={{ fontSize: '16px' }} value={notificationText} onChange={(e) => {setNotificationText(e.target.value)}} className="bg-black text-white border border-white rounded-lg p-1 text-sm"></textarea>
                </Li>
                <Div />
                <Div>
                    <MyButton click={sendNotification}>Отправить</MyButton>
                </Div>
                <Div />
                <MySnackBar
                    open={open}
                    text={message}
                    status={status}
                    close={closeSnack}
                />
            </Container>
        </div>
    )
}